import { Component, OnInit } from '@angular/core';
import { Utils } from '../../../common/utils';
import { MessageService, ConfirmationService, SelectItem } from 'primeng/api';
import { UntypedFormGroup} from '@angular/forms';
import { GenericService } from 'src/app/services/generic/generic.service';
import { urlUpload } from 'src/app/config/config';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from 'src/app/services/users/users.service';
import { StorageManager } from 'src/app/common/storage-manager.class';



@Component({
  selector: 'app-articulos-proveedor-list',
  templateUrl: './articulos-proveedor-list.component.html',
  styleUrls: ['./articulos-proveedor-list.component.css']
})
export class ArticulosProveedorListComponent implements OnInit {

  public cols = [
    { header: 'Foto', field: 'foto', width:'60px'},    
    { header: 'Nombre artículo', field: 'nombre'},
    { header: 'Descripción', field: 'descripcion'},    
  ];

  public es = Utils.es;
  public date2: Date;
  public expression = false;
  public title = "Artículos";
  public control: any = [];
  public TransporteData: any = [];
  public displayDialog = false;
  public editControl: any = [];
  public mostrar = false;
  public display: boolean = false;
  public createControlForm: UntypedFormGroup;
  public myMonth = "";
  public database = "warticulos";
  public database_origen = "articulos";

  public selectedOpciones: string = "";
  public oldValue: string = "";
  public columnasVisibles: boolean = false;
  public showInfo: boolean = true;
  public showDuplicate: boolean = true;
  public opciones: SelectItem[];

  public selectedColumns: any[];
  public anchoTabla = "1500px";
  public showTables: boolean = true;
  public listarTodos: boolean = true;
  public mostrarInformes: boolean = true;
  public displayMultiple: any;
  public urlImagen:string = urlUpload + 'articulos/';



  constructor(
    private genericService: GenericService,
    private messageService: MessageService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute
  ) {

    this.showCols();

  }

  ngOnInit(): void {

    this.iniciar();

  }

  iniciar() {
    this.mostrar = false;

    const isAdmin = localStorage.getItem('role').localeCompare('ROLE_ADMIN') == 0 ? true : false; 
    const where = isAdmin ? '' : 'id_proveedor = (SELECT p.id FROM proveedores p lEFT JOIN users u ON u.nombre = p.nombre WHERE u.id = ' + StorageManager.getUser().id + ' LIMIT 1)';


    this.genericService.getListSimple( this.database,'', where).toPromise().then((data: any) => {
      
      
      this.control = data.productos;
      
      this.mostarTabla();
      
    }).catch(error => {
      console.log("Error", error);
    });
  }

  listarCampos() {

    if (this.showTables) {
      this.showTables = false;
      this.columnasTotales();


    } else {
      this.showTables = true;
      this.columnasSimples();

    }
  }


  showCols(){

      this.columnasVisibles = false;
      this.anchoTabla = "1500px";
      this.selectedColumns = this.cols;
    
  }


  mostarTabla() {
    this.mostrar = true;
  }

  columnasSimples() {
    this.columnasVisibles = false;
    this.anchoTabla = "1500px";
    this.selectedColumns = this.cols;
  }
  columnasTotales() {
    this.columnasVisibles = false;
    this.anchoTabla = "4000px";
    this.selectedColumns = this.cols;
  }

  delete(id) {
    this.confirmationService.confirm({
      header: 'Confirmación',
      acceptLabel: 'Acceptar',
      rejectLabel: 'Cancelar',
      message: 'Quieres eliminar este registro?',
      accept: () => {

        this.genericService.delete( id, this.database_origen ).subscribe(data => {
          // console.log("Ha ido bien",data);
          this.iniciar();
        }, error => {
          console.error("error ", error);
        });
      }
    });

  }


  cerrar() {
    this.display = false;

    this.expression = false;
  }

  closeWindow(event) {
    this.cerrar();
  }

 


  duplicate(transporte) {
    let newId = "";
    this.genericService.clone(transporte.id, this.database_origen).toPromise().then((data:any) => {
     
      newId = data.id;

      this.messageService.add({ severity: 'success', summary: `Registro ${this.database_origen}`, detail: `Registro ${this.database_origen} Duplicado` });
      this.iniciar();
    }).catch(error => {
      this.messageService.add({ severity: 'error', summary: `Registro ${this.database_origen}`, detail: `Error en registro ${this.database_origen}` });
      console.log("error", error);
    });

  }

  arreglarfecha(fecha) {

    let arregloFecha = fecha.split("/");

    let myfecha = "";

    // console.log(myfecha);
    myfecha = arregloFecha[2] + "-" + arregloFecha[1] + "-" + arregloFecha[0];
    return myfecha;
  }


  public mydt: any;
  closeWindowMultpile(event) {
    this.consultar();
  }

  cambios(dt) {

    this.mydt = dt;

  }
  consultar() {

    if (this.displayMultiple) {
      this.displayMultiple = false;
    } else {
      this.displayMultiple = true;
    }
    if (this.mydt == null || this.mydt == undefined  || this.mydt.length == 0) {

    } else if (this.mydt.filteredValue == null || this.mydt == undefined) {

    } else {

    }
  }

  navegar(id){
    this.router.navigate(["/dashboard/articulos/edit/",id]);
  }

  createArticle() {
    this.router.navigate(['crear'], { relativeTo: this.route });
  }


}
